import { call, put, takeEvery } from "redux-saga/effects";
import GetDocumentRequest from "Communication/ApiClasses/GetDocumentRequest";
import * as actionTypes from "Redux/Actions/actionTypes";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";

// worker
function* handleGetDocument(action) {
  yield put(doLoadingStart("GET_DOCUMENT"));
  const getDocumentRequest = new GetDocumentRequest(
    action.data.memberNumber,
    action.data.docId
  );
  try {
    const result = yield call(getDocumentRequest.getData);
    yield put({
      type: actionTypes.GET_DOCUMENT_SUCCESS,
      response: result.data,
    });
    yield call(action.callback, result);
  } catch (error) {
    yield put({
      type: actionTypes.GET_DOCUMENT_ERROR,
      error,
    });
    yield call(action.callback, { error });
  } finally {
    yield put(doLoadingFinish("GET_DOCUMENT"));
  }
}

// watcher
export default function* getDocumentWatcherSaga() {
  yield takeEvery(actionTypes.GET_DOCUMENT, handleGetDocument);
}
